import { css } from 'styled-components';

export const getVariant =
  (variants) =>
  ({ variant }) =>
    variants[variant] ? variants[variant] : variants.default;

export const createTypography = (type, size) =>
  css`
    color: ${({ theme }) => theme.palette.navyGrayDarken5};
    font-weight: ${({ theme }) => theme.typography[type][size].fontWeight};
    font-size: ${({ theme }) => theme.typography[type][size].fontSize};
    line-height: ${({ theme }) => theme.typography[type][size].lineHeight};
    letter-spacing: ${({ theme }) => theme.typography[type][size].letterSpacing};
  `;
